import { BaseService, type ResponseMessage, type SearchRequest } from "@kiddocare-platform/portal-common/base";
import type { Instance } from "@kiddocare-platform/portal-common/clinical";
import type { InstanceDto } from "../components/configuration/instance-entity/root.component";

export class ClinicalExecutionService extends BaseService {

  public async SearchInstances(query: SearchRequest): Promise<ResponseMessage<Array<Instance>>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/searchInstances`, query);
      return response.data;
    } catch (error: any) {
      this.log.error("Search", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async GetByInstance(ticket: string): Promise<ResponseMessage<InstanceDto>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/execution/instances/getByInstance/${ticket}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetByInstance", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async SaveVisit(data: {
    idAccountPediatrician: bigint;
    idAccountPatient: bigint;
    day: string;
    startTime: string;
    idAvailability?: bigint;
    idOverride?: bigint;
    onOffice: boolean;
    onRemote: boolean;
    note?: string;
    reservedNote?: string
  }): Promise<ResponseMessage<Instance>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/saveVisit`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("SaveVisit", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async DeleteVisit(data: { idInstance: string; reasonResponse?: string }): Promise<ResponseMessage<void>> {
    try {
      const response = await this.AxiosInstance.delete(`/parent/execution/instances/deleteVisit`, { data });
      return response.data;
    } catch (error: any) {
      this.log.error("DeleteVisit", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}
